import classnames from 'classnames';
import React, { useCallback, useContext, useMemo, useState } from 'react';
import getStringFromObject from '@/utils/shared/getStringFromObject';
import { ThemeConfigContext } from '@/deps/basic';
import type { IScene, ITheme, IThemeConfig } from '@/deps/basic';

interface IMediaStyle {
    className: string;
    mobile: Record<string, string>;
    pad: Record<string, string>;
    laptop: Record<string, string>;
    pc: Record<string, string>;
    anchor?: string;
}

interface IProps {
    style: IMediaStyle;
    children: React.ReactNode;
    className?: string;
}

const CommonBox: React.FC<IProps> = (props) => {
    const defaultContext = useContext(ThemeConfigContext);
    const [scene, setScene] = useState<IScene>(__MERCHANT__);
    const [theme, setTheme] = useState<ITheme>(defaultContext.theme);
    const setSceneCallback = useCallback((scene: IScene): void => {
        setScene(scene);
    }, []);
    const setThemeCallback = useCallback((theme: ITheme): void => {
        setTheme(theme);
    }, []);
    const themeConfig = useMemo((): IThemeConfig => {
        return {
            scene,
            theme,
            setScene: setSceneCallback,
            setTheme: setThemeCallback
        };
    }, [scene, theme, setSceneCallback, setThemeCallback]);

    // reolink暂时没有全局模版，为了兼容reolink，在commonBox给body加上主题变量css类，reolink有全局模版后会去掉
    React.useEffect(() => {
        const themeClass = `theme-${__MERCHANT__}-root`;
        if (!document.body.classList.contains(themeClass)) {
            document.body.classList.add(themeClass);
        }
    }, []);

    return (
        <ThemeConfigContext.Provider value={ themeConfig }>
            <div
                id={ props.style.anchor }
            >
                <style>
                    {
                        `
                    @media screen and (max-width: 767px){
                        .${props.style.className}{${getStringFromObject(props.style.mobile ?? {})}}
                    }
                    @media screen and (min-width:768px) and (max-width: 1023px){
                        .${props.style.className}{${getStringFromObject(props.style.pad ?? {})}}
                    }
                    @media screen and (min-width: 1024px) and (max-width: 1279px){
                        .${props.style.className}{${getStringFromObject(props.style.laptop ?? {})}}
                    }
                    @media screen and (min-width: 1280px){
                        .${props.style.className}{${getStringFromObject(props.style.pc ?? {})}}
                    }
                    `
                    }
                </style>
                <div
                    className={ classnames(props.style.className ?? '', props.className) }
                    style={{ backgroundSize: 'cover', backgroundPosition: 'center' }}
                >
                    {props.children}
                </div>
            </div>
        </ThemeConfigContext.Provider>
    );
};

export default CommonBox;
